import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function zipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return { invalidZip: true };
    }

    const filtered = control.value.replace(/\D/g, '');
    return filtered.length === 5 || filtered.length === 9 ? null : { invalidZip: true };
  };
}
